import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, auditServiceJsonLdScript } from "@/lib/seo";
import { AuditPage } from "@/pages/audit";

export const Route = createFileRoute("/$lang/audit")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    const head = pageHead({
      lang,
      pathWithoutLang: "/audit",
      title: t("audit.title"),
      description: t("audit.description"),
    });
    return { ...head, scripts: [auditServiceJsonLdScript(lang)] };
  },
  component: AuditPage,
});
